import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

/* Get Failed File Data */

export const FilesData = createAsyncThunk(
    "filesData",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.itemDetails, arg);            
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const FilesDataSlice = createSlice({
    name: "filesData",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        filesDataReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        }
    },
        extraReducers: {
            [FilesData.fulfilled]: (state, { payload }) => {
                state.isLoading = false;
                state.success = true;
                state.data = payload;
                state.error = false;
            },
            [FilesData.pending]: (state) => {
                state.isLoading = true;
                state.data = false;
                state.error = null;
            },
            [FilesData.rejected]: (state, { payload }) => {
                state.isLoading = false;
                state.error = payload;
                state.success = false;
            },
        },
})

/* Download Failed File */

export const DownloadFailedFile = createAsyncThunk(
    "downloadFile",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.downloadFailedFile, arg);                                    
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const DownloadFailedFileSlice = createSlice({
    name: "downloadFile",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        downloadFailedFilesReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        }
    },
        extraReducers: {
            [DownloadFailedFile.fulfilled]: (state, { payload }) => {
                state.isLoading = false;
                state.success = true;
                state.data = payload;
                state.error = false;
            },
            [DownloadFailedFile.pending]: (state) => { 
                state.isLoading = true;
                state.data = false;
                state.error = null;
            },
            [DownloadFailedFile.rejected]: (state, { payload }) => {
                state.isLoading = false;
                state.error = payload;
                state.success = false;
            },
        },
})

export const { filesDataReset } = FilesDataSlice.actions;
export const { downloadFailedFilesReset } = DownloadFailedFileSlice.actions;